export class FetchError extends Error {
    status: number;
    
    constructor(message: string, status: number) {
        super(message);
        this.status = status;
        this.name = 'FetchError';
    }
}

export const fetcher = (url) => fetch(url).then(async (res) => {
    if (res.status >= 200 && res.status < 300) {
        return res.json();
    }
    const errorText = await res.text();
    throw new FetchError(errorText || `HTTP ${res.status}`, res.status);
});
